/// <reference path="../../../../../rcwebmodels/reeferstatus.cs.d.ts" />
import * as React from 'react';
import { PopupWindow } from './../sharedcomponents/PopupWindow';
import $ from 'jquery';
import { RCUtils } from './../../RCUtils';
import uniq from 'lodash/uniq';
import * as Autosuggest from 'react-autosuggest';
import * as RCNGWindow from './../sharedcomponents/ConfirmationWindow';
var Config: any = require('../../Config.json');

var self;
var methodResult = true;
var selReefers;
var selectedUnits = "";

export interface EditVesselVVCState {
    VoyageEdit: server.VoyageEdit;
    IsCommandIssued: boolean;
    PrevSelectedItems: any[];
    RefVessels: server.vesselsList[];
    SelectedReefers: any[];
    suggestionsVesselId: any[],
    suggestionsVoyage: any[],
    suggestionsCalls: any[],
    ArrsuggestionsVesselId: any[],
    ArrsuggestionsVoyage: any[],
    ArrsuggestionsCalls: any[],
}
var newVoyage: server.VoyageEdit = {
    SelectedReefers: [],
    Unitmasterid: 0,
    ReeferId: '',
    IsVVCModified: false,
    SelectedVesselCD: '',
    SelectedCall: '',
    SelectedVoyage: '',
    ArrSelectedVesselCD: '',
    ArrSelectedCall: '',
    ArrSelectedVoyage: '', userInput: 0
};
export class EditVoyageVVC extends React.Component<any, EditVesselVVCState> {
    constructor(props: any) {

        super(props);
        this.state = {
            IsCommandIssued: false, PrevSelectedItems: [], SelectedReefers: [], VoyageEdit: newVoyage, RefVessels: [], suggestionsVesselId: [], suggestionsVoyage: [], suggestionsCalls: [], ArrsuggestionsVesselId: [], ArrsuggestionsVoyage: [], ArrsuggestionsCalls: []
        };

        this.getVVCInfo();
        self = this;
    }
    getVVCInfo() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/Getvessels')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.length > 0) {
                    this.setState({ RefVessels: data });
                }
            });
    }


    componentWillReceiveProps(nextprops: any) {
        var reeferData = nextprops.reeferData;
        this.setState({ SelectedReefers: reeferData }, () => { this.getVVCInfo(); });
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            var VoyageEdit: server.VoyageEdit = JSON.parse(JSON.stringify(newVoyage));
            var reeferLst = [];
            var reeferDisplayStr = "";
            if (reeferData.length > 1) {
                $.each(reeferData, function (ind, val) {
                    if (val.ReeferID != "") {
                        reeferLst.push(val.ReeferID);
                    }
                });
                reeferDisplayStr = reeferLst.join(', ');
                VoyageEdit.ReeferId = this.FormatReeferStringWithDotDot(reeferDisplayStr, 100);
            }
            else { VoyageEdit.ReeferId = reeferData[0].ReeferID; }

            if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
                if (reeferData[0].LifecycleCd == 'L' || reeferData[0].LifecycleCd == 'R' || reeferData[0].LifecycleCd == 'D' || reeferData[0].LifecycleCd == 'P') {
                    var departingVVC = reeferData[0].DepartingVVC.split('-');
                    var depVoyage = departingVVC[0].trim().length > 0 ? departingVVC[0].trim() : '';
                    var depCall = departingVVC[1].trim().length > 0 ? departingVVC[1].trim() : '';
                    var arrivingVVC = reeferData[0].ArrivingVVC.split('-');
                    var arrVoyage = arrivingVVC[0].trim().length > 0 ? arrivingVVC[0].trim() : '';
                    var arrCall = arrivingVVC[1].trim().length > 0 ? arrivingVVC[1].trim() : '';

                    VoyageEdit.SelectedVoyage = depVoyage;
                    VoyageEdit.SelectedCall = depCall;
                    VoyageEdit.SelectedVesselCD = depVoyage != '' ? reeferData[0].VoyageVesselCd != null ? reeferData[0].VoyageVesselCd : '' : '';
                    VoyageEdit.ArrSelectedVesselCD = arrVoyage != '' ? reeferData[0].VoyageVesselCd != null ? reeferData[0].VoyageVesselCd : '' : '';
                    VoyageEdit.ArrSelectedVoyage = arrVoyage;
                    VoyageEdit.ArrSelectedCall = arrCall;
                }
                this.setState({ VoyageEdit });
            }
        }
    }

    componentDidMount() {
        var reeferData = this.props.reeferData;
        this.setState({ SelectedReefers: reeferData });
        var VoyageEdit: server.VoyageEdit = JSON.parse(JSON.stringify(newVoyage));
        var reeferLst = [];
        var reeferDisplayStr = "";
        if (reeferData.length > 1) {
            $.each(reeferData, function (ind, val) {
                if (val.ReeferID != "") {
                    reeferLst.push(val.ReeferID);
                }
            });
            reeferDisplayStr = reeferLst.join(', ');
            VoyageEdit.ReeferId = this.FormatReeferStringWithDotDot(reeferDisplayStr, 100);
        }
        else { VoyageEdit.ReeferId = reeferData[0].ReeferID; }
        if (reeferData != undefined && reeferData != null && reeferData.length > 0) {
            if (reeferData[0].LifecycleCd == 'L' || reeferData[0].LifecycleCd == 'R' || reeferData[0].LifecycleCd == 'D' || reeferData[0].LifecycleCd == 'P') {
                var departingVVC = reeferData[0].DepartingVVC.split('-');
                var depVoyage = departingVVC[0].trim().length > 0 ? departingVVC[0].trim() : '';
                var depCall = departingVVC[1].trim().length > 0 ? departingVVC[1].trim() : '';
                var arrivingVVC = reeferData[0].ArrivingVVC.split('-');
                var arrVoyage = arrivingVVC[0].trim().length > 0 ? arrivingVVC[0].trim() : '';
                var arrCall = arrivingVVC[1].trim().length > 0 ? arrivingVVC[1].trim() : '';

                VoyageEdit.SelectedVoyage = depVoyage;
                VoyageEdit.SelectedCall = depCall;
                VoyageEdit.SelectedVesselCD = depVoyage != '' ? reeferData[0].VoyageVesselCd != null ? reeferData[0].VoyageVesselCd : '' : '';
                VoyageEdit.ArrSelectedVesselCD = arrVoyage != '' ? reeferData[0].VoyageVesselCd != null ? reeferData[0].VoyageVesselCd : '' : '';
                VoyageEdit.ArrSelectedVoyage = arrVoyage;
                VoyageEdit.ArrSelectedCall = arrCall;
            }
            this.setState({ VoyageEdit });
        }
    }

    FormatReeferStringWithDotDot(str, length) {
        if (str.length > length) {
            return str.substring(0, length) + ' ...';
        } else {
            return str;
        }
    }
    onSuggestionsFetchRequestedforvessel = ({ value }) => {
        this.setState({
            suggestionsVesselId: this.getvesselNameSuggestions(value)
        });
    };
    getvesselNameSuggestions(value) {

        var VesselData = this.state.RefVessels.map(fence => fence.VesselCd);
        var vessels = uniq(VesselData);
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : vessels.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };
    onSuggestionsClearRequestedforvessel = () => {
        this.setState({
            suggestionsVesselId: []
        });
    };
    onChangeVesselId = (event, { newValue }) => {
        var filters = this.state.VoyageEdit;
        filters.SelectedVesselCD = newValue;
        filters.SelectedVoyage = '';
        filters.SelectedCall = '';


        this.setState({
            VoyageEdit: filters
        });
        this.setState({
            suggestionsVoyage: this.getvoyageNameSuggestions(newValue)
        });
    };
    onChangcall = (event, { newValue }) => {
        var filters = this.state.VoyageEdit;
        filters.SelectedCall = newValue;


        this.setState({
            VoyageEdit: filters
        });
    };
    renderSuggestionVesselvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionVesselValue(suggestion) {
        return suggestion;
    }
    onSuggestionsFetchRequestedforvoyage = ({ value }) => {
        this.setState({
            suggestionsVoyage: this.voyageNameSuggestions(value)
        });
    };
    onSuggestionsFetchRequestedforcall = ({ value }) => {
        this.setState({
            suggestionsCalls: this.callSuggestions(value)
        });
    };
    callSuggestions(value) {
        if (this.state.VoyageEdit.SelectedVesselCD != "" && this.state.VoyageEdit.SelectedVesselCD != null && this.state.VoyageEdit.SelectedVoyage != "" && this.state.VoyageEdit.SelectedVoyage != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.VoyageEdit.SelectedVesselCD
                && tag.VoyageNum === this.state.VoyageEdit.SelectedVoyage && tag.CallNum.toLowerCase().slice(0, inputLength) === inputValue
            );

            return uniq(test.map(fence => fence.CallNum));
        }
        else
            return [];
    };
    voyageNameSuggestions(value) {
        if (this.state.VoyageEdit.SelectedVesselCD != "" && this.state.VoyageEdit.SelectedVesselCD != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.VoyageEdit.SelectedVesselCD
                && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            return uniq(test.map(fence => fence.VoyageNum));
        }
        else
            return [];
    };
    getvoyageNameSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag =>
            tag.VesselCd.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.VoyageNum));
    };
    getcallSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.VoyageEdit.SelectedVesselCD
            && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.CallNum));
    };
    onSuggestionsClearRequestedforvoyage = () => {
        this.setState({
            suggestionsVoyage: []
        });
    };
    onSuggestionsClearRequestedforcall = () => {
        this.setState({
            suggestionsCalls: []
        });
    };
    onChangevoyage = (event, { newValue }) => {
        var filters = this.state.VoyageEdit;
        filters.SelectedVoyage = newValue;

        filters.SelectedCall = '';
        this.setState({
            VoyageEdit: filters
        });
        this.setState({
            suggestionsCalls: this.getcallSuggestions(newValue)
        });
    };
    renderSuggestionvoyagevalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionvoyageValue(suggestion) {
        return suggestion;
    }
    renderSuggestioncallvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestioncallValue(suggestion) {
        return suggestion;
    }

    onSuggestionsFetchRequestedforArrvessel = ({ value }) => {
        this.setState({
            ArrsuggestionsVesselId: this.getArrvesselNameSuggestions(value)
        });
    };
    getArrvesselNameSuggestions(value) {

        var VesselData = this.state.RefVessels.map(fence => fence.VesselCd);
        var vessels = uniq(VesselData);
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : vessels.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };
    onSuggestionsClearRequestedforArrvessel = () => {
        this.setState({
            ArrsuggestionsVesselId: []
        });
    };
    onChangeArrVesselId = (event, { newValue }) => {
        var filters = this.state.VoyageEdit;
        filters.ArrSelectedVesselCD = newValue;
        filters.ArrSelectedVoyage = '';
        filters.ArrSelectedCall = '';

        this.setState({
            VoyageEdit: filters
        });
        this.setState({
            ArrsuggestionsVoyage: this.getArrvoyageNameSuggestions(newValue)
        });
    };
    onChangArrcall = (event, { newValue }) => {
        var filters = this.state.VoyageEdit;
        filters.ArrSelectedCall = newValue;

        this.setState({
            VoyageEdit: filters
        });
    };
    renderSuggestionArrVesselvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionArrVesselValue(suggestion) {
        return suggestion;
    }
    onSuggestionsFetchRequestedforArrvoyage = ({ value }) => {
        this.setState({
            ArrsuggestionsVoyage: this.ArrvoyageNameSuggestions(value)
        });
    };
    onSuggestionsFetchRequestedforArrcall = ({ value }) => {
        this.setState({
            ArrsuggestionsCalls: this.ArrcallSuggestions(value)
        });
    };
    ArrcallSuggestions(value) {
        if (this.state.VoyageEdit.ArrSelectedVesselCD != "" && this.state.VoyageEdit.ArrSelectedVesselCD != null && this.state.VoyageEdit.ArrSelectedVoyage != "" && this.state.VoyageEdit.ArrSelectedVoyage != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.VoyageEdit.ArrSelectedVesselCD
                && tag.VoyageNum === this.state.VoyageEdit.ArrSelectedVoyage && tag.CallNum.toLowerCase().slice(0, inputLength) === inputValue
            );

            return uniq(test.map(fence => fence.CallNum));
        }
        else
            return [];
    };
    ArrvoyageNameSuggestions(value) {
        if (this.state.VoyageEdit.ArrSelectedVesselCD != "" && this.state.VoyageEdit.ArrSelectedVesselCD != null) {
            var VesselData = this.state.RefVessels;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.VoyageEdit.ArrSelectedVesselCD
                && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            return uniq(test.map(fence => fence.VoyageNum));
        }
        else
            return [];
    };
    getArrvoyageNameSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag =>
            tag.VesselCd.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.VoyageNum));
    };
    getArrcallSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.VoyageEdit.ArrSelectedVesselCD
            && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.CallNum));
    };
    onSuggestionsClearRequestedforArrvoyage = () => {
        this.setState({
            ArrsuggestionsVoyage: []
        });
    };
    onSuggestionsClearRequestedforArrcall = () => {
        this.setState({
            ArrsuggestionsCalls: []
        });
    };
    onChangeArrvoyage = (event, { newValue }) => {
        var filters = this.state.VoyageEdit;
        filters.ArrSelectedVoyage = newValue;
        filters.ArrSelectedCall = '';
        this.setState({
            VoyageEdit: filters
        });
        this.setState({
            ArrsuggestionsCalls: this.getArrcallSuggestions(newValue)
        });
    };
    renderSuggestionArrvoyagevalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionArrvoyageValue(suggestion) {
        return suggestion;
    }
    renderSuggestionArrcallvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionArrcallValue(suggestion) {
        return suggestion;
    }




    submitVVCEditDetails() {
        //$('#globalLoader').show();
        var VoyageEdit: server.VoyageEdit = JSON.parse(JSON.stringify(this.state.VoyageEdit));
        const { SelectedVesselCD, SelectedVoyage, SelectedCall, ArrSelectedVesselCD, ArrSelectedVoyage, ArrSelectedCall } = this.state.VoyageEdit;
        const { VoyageDepartingVVC, ArrivingVVC, VoyageVesselCd, LifecycleCd } = this.state.SelectedReefers[0];
        var PrevDepartingVoyage = VoyageDepartingVVC.split('-')[0].trim();
        var PrevDepartingCall = VoyageDepartingVVC.split('-')[1].trim();
        var PrevArrivalVoyage = ArrivingVVC.split('-')[0].trim();
        var PrevArrivalCall = ArrivingVVC.split('-')[1].trim();

        var currentdepartingVVC = VoyageVesselCd + ',' + PrevDepartingVoyage + ',' + PrevDepartingCall;
        var currentarrivalVVC = (PrevArrivalVoyage != '' ? VoyageVesselCd : '') + ',' + PrevArrivalVoyage + ',' + PrevArrivalCall;
        var chosenDepartingVVC = SelectedVesselCD + ',' + SelectedVoyage + ',' + SelectedCall;
        var chosenArrivalVVC = ArrSelectedVesselCD + ',' + ArrSelectedVoyage + ',' + ArrSelectedCall;

        if (LifecycleCd == 'C' || LifecycleCd == null)
            currentdepartingVVC = ',,';

        if (LifecycleCd == 'C' || LifecycleCd == null)
            currentarrivalVVC = ',,';

        if (currentdepartingVVC != chosenDepartingVVC || currentarrivalVVC != chosenArrivalVVC)
            this.state.VoyageEdit.IsVVCModified = true;
        else
            this.state.VoyageEdit.IsVVCModified = false;
        if (!this.state.VoyageEdit.IsVVCModified) {
            PopupWindow.showErrorMessage("Alert", "Please modify VVC details");
            return;
        }
        this.ValidateVVCandSubmit();
    }
    ValidateVVCandSubmit() {
        const { SelectedVesselCD, SelectedVoyage, SelectedCall, ArrSelectedVesselCD, ArrSelectedVoyage, ArrSelectedCall } = this.state.VoyageEdit;
        var vesselHasVoyageCalls;

        if (SelectedVesselCD != '' && SelectedVesselCD != null) {
            var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == SelectedVesselCD.toUpperCase());
            if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                vesselHasVoyageCalls = selectedVessel[0].VoyagesHaveCalls;
            }

            if (SelectedVesselCD != null && SelectedVesselCD != '' && ArrSelectedVesselCD != null && ArrSelectedVesselCD != '') {
                if (SelectedVesselCD != ArrSelectedVesselCD) {
                    PopupWindow.showErrorMessage('Alert', 'Departing and Arriving VVC should be same');
                    return false;
                }
            }
        }

        if (((SelectedVesselCD == '' && SelectedVoyage == '' && SelectedCall == '') || (SelectedVesselCD != '' && SelectedVoyage != '' && (!vesselHasVoyageCalls || (vesselHasVoyageCalls && SelectedCall != '')))) &&
            ((ArrSelectedVesselCD == '' && ArrSelectedVoyage == '' && ArrSelectedCall == '') || (ArrSelectedVesselCD != '' && ArrSelectedVoyage != '' && (!vesselHasVoyageCalls || (vesselHasVoyageCalls && ArrSelectedCall != ''))))) {
            var DepVVC = SelectedVesselCD + ',' + SelectedVoyage + ',' + SelectedCall;
            var ArrVVC = ArrSelectedVesselCD + ',' + ArrSelectedVoyage + ',' + ArrSelectedCall;

            var url = Config.ApiBaseUrl + '/api/reeferstatus/ValidateVVCEntered?DepVVC=' + DepVVC + '&ArrVVC=' + ArrVVC;
            var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            RCUtils.fetchRetry(request)
                .then(RCUtils.handleResponse)
                .then(response => response.json() as Promise<string>)
                .then(data => {
                    if (data != '') {
                        if (data == 'DNE')
                            PopupWindow.showErrorMessage("Error", 'The Departing VVC, ' + SelectedVesselCD + ' ' + SelectedVoyage + ' ' + SelectedCall + ', does not exist. A VVC cannot be created here.');
                        else if (data == 'ANE')
                            PopupWindow.showErrorMessage("Error", 'The Arriving VVC, ' + ArrSelectedVesselCD + ' ' + ArrSelectedVoyage + ' ' + ArrSelectedCall + ', does not exist. A VVC cannot be created here.');
                        return false;
                    }
                    else {
                        this.OnSubmitVVCValidations();
                    }
                });
        }
        else {
            if (SelectedVesselCD != null && SelectedVesselCD != '' && ArrSelectedVesselCD != null && ArrSelectedVesselCD != '') {
                if (SelectedVesselCD != ArrSelectedVesselCD) {
                    PopupWindow.showErrorMessage('Alert', 'Departing and Arriving VVC should be same');
                    return false;
                }
            }

            var voyagesHaveCalls;
            if (SelectedVesselCD != '' && SelectedVesselCD != null) {
                var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == SelectedVesselCD.toUpperCase());
                if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                    voyagesHaveCalls = selectedVessel[0].VoyagesHaveCalls;
                }
                else {
                    PopupWindow.showErrorMessage('Alert', 'Departing VVC not exists');
                    return false;
                }
            }

            if (SelectedVesselCD == '') {
                PopupWindow.showErrorMessage('Alert', 'A vessel code must be specified for the Departing VVC.');
                return false;
            }
            else if (ArrSelectedVesselCD == '') {
                PopupWindow.showErrorMessage('Alert', 'A vessel code must be specified for the Arriving VVC.');
                return false;
            }
            else if (SelectedVesselCD != '' && SelectedVoyage == '') {
                PopupWindow.showErrorMessage('Alert', 'A voyage number must be specified for the Departing VVC.');
                return false;
            }
            else if (SelectedVesselCD != '' && voyagesHaveCalls && SelectedCall == '') {
                PopupWindow.showErrorMessage('Alert', 'A call must be specified for the Departing VVC.');
                return false;
            }
            else if (ArrSelectedVesselCD != '' && ArrSelectedVoyage == '') {
                PopupWindow.showErrorMessage('Alert', 'A voyage number must be specified for the Arriving VVC.');
                return false;
            }
            else if (ArrSelectedVesselCD != '' && voyagesHaveCalls && ArrSelectedCall == '') {
                PopupWindow.showErrorMessage('Alert', 'A call must be specified for the Arriving VVC.');
                return false;
            }
        }
    }

    closeUserConfirmation() {
        methodResult = false;
        RCNGWindow.ConfirmWindow.close();
        return false;
    }

    SaveUserInputToState(userInput: number) {
        $('#globalLoader').show();
        var VoyageEdit: server.VoyageEdit = JSON.parse(JSON.stringify(this.state.VoyageEdit));
        VoyageEdit.userInput = userInput;

        methodResult = true;
        this.setState({ VoyageEdit }, () => {
            RCNGWindow.ConfirmWindow.close();
            this.submitEditVoyageAfterPrompt();
        });
    }
    submitEditVoyageAfterPrompt() {

        this.state.VoyageEdit.Unitmasterid = this.state.SelectedReefers[0].UnitMasterID;
        var selUnits = [];

        if (this.state.SelectedReefers.length > 1) {
            $.each(this.state.SelectedReefers, function (index, value) {
                selectedUnits = selectedUnits == "" ? value.UnitMasterID : selectedUnits + "," + value.UnitMasterID;
            });
        }
        else {
            selectedUnits = this.state.SelectedReefers[0].UnitMasterID.toString();
        }

        $.each(selectedUnits.split(','), function (index, value) {
            selUnits.push(parseInt(value));
        });

        this.state.VoyageEdit.SelectedReefers = selUnits;
        //$('#globalLoader').show();
        var voyageEdit = JSON.stringify(this.state.VoyageEdit);
        var url = Config.ApiBaseUrl + '/api/reeferstatus/EditVoyage';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: voyageEdit, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                $('#globalLoader').hide();
                if (data == 'Voyage edited successfully') {
                    $("#contextMenuModel .btn-close").click();
                    this.setState({ IsCommandIssued: true, PrevSelectedItems: this.props.reeferData }, () => { this.props.IsCommandIssued(this.state.IsCommandIssued); this.props.PrevSelectedItems(this.props.reeferData) });
                    this.props.refreshStatusGrid();

                    PopupWindow.showErrorMessage("Edit Voyage", "Voyage edited successfully");

                }
                else {
                    PopupWindow.showErrorMessage("Edit Voyage", data);
                }
            });
    }

    OnSubmitVVCValidations() {
        methodResult = false;
        const { SelectedVesselCD, SelectedVoyage, SelectedCall, ArrSelectedVesselCD, ArrSelectedVoyage, ArrSelectedCall } = this.state.VoyageEdit;
        const { VoyageDepartingVVC, ArrivingVVC, VoyageVesselCd, LifecycleCd } = this.state.SelectedReefers[0];
        var PrevDepartingVoyage = VoyageDepartingVVC.split('-')[0].trim();
        var PrevDepartingCall = VoyageDepartingVVC.split('-')[1].trim();
        var PrevArrivalVoyage = ArrivingVVC.split('-')[0].trim();
        var PrevArrivalCall = ArrivingVVC.split('-')[1].trim();

        var currentdepartingVVC = (VoyageVesselCd == null ? '' : VoyageVesselCd) + ',' + PrevDepartingVoyage + ',' + PrevDepartingCall;
        var currentarrivalVVC = (PrevArrivalVoyage != '' ? VoyageVesselCd : '') + ',' + PrevArrivalVoyage + ',' + PrevArrivalCall;
        var chosenDepartingVVC = SelectedVesselCD + ',' + SelectedVoyage + ',' + SelectedCall;
        var chosenArrivalVVC = ArrSelectedVesselCD + ',' + ArrSelectedVoyage + ',' + ArrSelectedCall;

        var submitVVCInputData: server.SubmitVVCInputData = {
            CurrentDepVVC: (LifecycleCd == 'C' || LifecycleCd == null) ? ',,' : currentdepartingVVC,
            CurrentArrVVC: (LifecycleCd == 'C' || LifecycleCd == null) ? ',,' : currentarrivalVVC,
            ChosenDepVVC: chosenDepartingVVC,
            ChosenArrVVC: chosenArrivalVVC,
            LifecycleCd: LifecycleCd
        }
        var inputBody = JSON.stringify(submitVVCInputData);
        var url = Config.ApiBaseUrl + '/api/reeferstatus/SubmitVVC';
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: inputBody, headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.SubmitVVCResult>)
            .then(data => {
                if (data.IsPromptMessage) {
                    $('#globalLoader').hide();
                    RCNGWindow.ConfirmWindow.showConfirmBox(data.ResultMessage, this.SaveUserInputToState.bind(this, data.PromptId), this.closeUserConfirmation.bind(this));
                }
                else if (!data.IsPromptMessage && data.ResultMessage != null && data.ResultMessage != '') {
                    PopupWindow.showErrorMessage('Error', data.ResultMessage);
                    methodResult = false;
                    return methodResult;
                }
                else {
                    this.SaveUserInputToState(data.PromptId);
                    return methodResult;
                }
            });
    }
    public render() {
        var Voyagedisabled: any;
        var Calldisabled: any;
        if (this.state.VoyageEdit.SelectedVesselCD != "" && this.state.VoyageEdit.SelectedVesselCD != null) {
            Voyagedisabled = false;
            Calldisabled = true;
        }
        else {
            Voyagedisabled = true;
            Calldisabled = true;
        }
        if (this.state.VoyageEdit.SelectedVoyage != "" && this.state.VoyageEdit.SelectedVoyage != null) {

            var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == this.state.VoyageEdit.SelectedVesselCD.toUpperCase());
            if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                var vesselHasVoyageCalls = selectedVessel[0].VoyagesHaveCalls;
                if (vesselHasVoyageCalls)
                    Calldisabled = false;
                else
                    Calldisabled = true;
            }
        }
        else {
            Calldisabled = true;
        }
        var ArrVoyagedisabled: any;
        var ArrCalldisabled: any;
        if (this.state.VoyageEdit.ArrSelectedVesselCD != "" && this.state.VoyageEdit.ArrSelectedVesselCD != null) {
            ArrVoyagedisabled = false;
            ArrCalldisabled = true;
        }
        else {
            ArrVoyagedisabled = true;
            ArrCalldisabled = true;
        }
        if (this.state.VoyageEdit.ArrSelectedVoyage != "" && this.state.VoyageEdit.ArrSelectedVoyage != null) {

            var selectedVessel = this.state.RefVessels.filter(x => x.VesselCd.toUpperCase() == this.state.VoyageEdit.ArrSelectedVesselCD.toUpperCase());
            if (selectedVessel != null && selectedVessel != undefined && selectedVessel.length > 0) {
                var vesselHasVoyageCalls = selectedVessel[0].VoyagesHaveCalls;
                if (vesselHasVoyageCalls)
                    ArrCalldisabled = false;
                else
                    ArrCalldisabled = true;
            }
        }
        else {
            ArrCalldisabled = true;
        }
        const { suggestionsVesselId, suggestionsVoyage, suggestionsCalls, ArrsuggestionsVesselId, ArrsuggestionsVoyage, ArrsuggestionsCalls } = this.state;

        const FenceIdListinputPropsforvessel = {
            id: 'vesselID',
            placeholder: 'Vessel',
            value: this.state.VoyageEdit.SelectedVesselCD,
            onChange: this.onChangeVesselId.bind(this),
        };
        const FenceIdListinputPropsforvoyage = {
            id: 'voyageNum',
            placeholder: 'Voyage',
            value: this.state.VoyageEdit.SelectedVoyage,
            onChange: this.onChangevoyage.bind(this),
            disabled: Voyagedisabled,
        };
        const FenceIdListinputPropsforcall = {
            id: 'CallNum',
            placeholder: 'Call',
            value: this.state.VoyageEdit.SelectedCall,
            onChange: this.onChangcall.bind(this),
            disabled: Calldisabled,
        };
        const FenceIdListinputPropsforArrvessel = {
            id: 'vesselID',
            placeholder: 'Vessel',
            value: this.state.VoyageEdit.ArrSelectedVesselCD,
            onChange: this.onChangeArrVesselId.bind(this),
        };
        const FenceIdListinputPropsforArrvoyage = {
            id: 'voyageNum',
            placeholder: 'Voyage',
            value: this.state.VoyageEdit.ArrSelectedVoyage,
            onChange: this.onChangeArrvoyage.bind(this),
            disabled: ArrVoyagedisabled,
        };
        const FenceIdListinputPropsforArrcall = {
            id: 'CallNum',
            placeholder: 'Call',
            value: this.state.VoyageEdit.ArrSelectedCall,
            onChange: this.onChangArrcall.bind(this),
            disabled: ArrCalldisabled,
        };
        return <div>
            <div className="modal-controls-container">
                <div className="row" >
                    <div className="col-lg-2 col-md-6 text-start text-lg-end pe-0" >
                        <span className='col-form-label'>Reefer ID:</span>
                    </div>
                    <div className="col-lg-9" >
                        <div className='form-text'>
                            {(this.state.VoyageEdit != undefined) ? this.state.VoyageEdit.ReeferId : ''}
                        </div>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-lg-2 col-md-6 text-start text-lg-end pe-0"><label className='col-form-label'>Departing VVC: </label></div>
                    <div className="col-lg-3 col-md-12">
                        <Autosuggest name="vesselID" id="vesselID"
                            suggestions={suggestionsVesselId}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforvessel}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforvessel}
                            getSuggestionValue={this.getSuggestionVesselValue}
                            renderSuggestion={this.renderSuggestionVesselvalue}
                            inputProps={FenceIdListinputPropsforvessel}
                            highlightFirstSuggestion={true}
                        />
                    </div>
                    <div className="col-lg-3 col-md-12">
                        <Autosuggest name="voyage" id="voyage"
                            suggestions={suggestionsVoyage}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforvoyage}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforvoyage}
                            getSuggestionValue={this.getSuggestionvoyageValue}
                            renderSuggestion={this.renderSuggestionvoyagevalue}
                            inputProps={FenceIdListinputPropsforvoyage}
                            highlightFirstSuggestion={true}
                        />
                    </div>
                    <div className="col-lg-3 col-md-12">
                        <Autosuggest name="Call" id="Call"
                            suggestions={suggestionsCalls}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforcall}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforcall}
                            getSuggestionValue={this.getSuggestioncallValue}
                            renderSuggestion={this.renderSuggestioncallvalue}
                            inputProps={FenceIdListinputPropsforcall}
                            highlightFirstSuggestion={true}
                        />
                    </div>

                </div>
                <div className="row mt-2">
                    <div className="col-lg-2 col-md-6 text-start text-lg-end pe-0"><label className='col-form-label'>Arriving VVC: </label></div>
                    <div className="col-lg-3 col-md-12">
                        <Autosuggest name="ArrvesselID" id="ArrvesselID"
                            suggestions={ArrsuggestionsVesselId}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforArrvessel}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforArrvessel}
                            getSuggestionValue={this.getSuggestionArrVesselValue}
                            renderSuggestion={this.renderSuggestionArrVesselvalue}
                            inputProps={FenceIdListinputPropsforArrvessel}
                            highlightFirstSuggestion={true}
                        />
                    </div>
                    <div className="col-lg-3 col-md-12">
                        <Autosuggest name="Arrvoyage" id="Arrvoyage"
                            suggestions={ArrsuggestionsVoyage}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforArrvoyage}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforArrvoyage}
                            getSuggestionValue={this.getSuggestionArrvoyageValue}
                            renderSuggestion={this.renderSuggestionArrvoyagevalue}
                            inputProps={FenceIdListinputPropsforArrvoyage}
                            highlightFirstSuggestion={true}
                        />
                    </div>
                    <div className="col-lg-3 col-md-12">
                        <Autosuggest name="ArrCall" id="ArrCall"
                            suggestions={ArrsuggestionsCalls}
                            onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforArrcall}
                            onSuggestionsClearRequested={this.onSuggestionsClearRequestedforArrcall}
                            getSuggestionValue={this.getSuggestionArrcallValue}
                            renderSuggestion={this.renderSuggestionArrcallvalue}
                            inputProps={FenceIdListinputPropsforArrcall}
                            highlightFirstSuggestion={true}
                        />
                    </div>
                </div>
               
            </div>

            <div className="modal-footer mt-3">
                <button type="button" id="hidePopUpBtn" className="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                <button type="button" className="btn btn-primary" onClick={this.submitVVCEditDetails.bind(this)}>Save</button>
            </div>
        </div>;
    }
}

